module.exports = __webpack_public_path__ + "img/86.de77852a.jpg";